import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Table, Tag, Tooltip} from "antd";
import Colors from "../../../styles/Colors";
import {BiDownload, BiPlus, BiRefresh} from "react-icons/bi";
import {
    BsBoxArrowInDown,
    BsCheckCircle,
    BsCheckCircleFill,
    BsClipboardCheck,
    BsClipboardCheckFill,
    BsEnvelope,
    BsEnvelopeOpen
} from "react-icons/bs";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import ComandaGenerada from "../../../model/menudesign/comandes/ComandaGenerada";
import {format} from "date-fns";
import {GetComandesGenerades} from "../../../dao/menudesign/comandes/GetComandesGenerades";
import {GetComandesGeneradesIdPdf} from "../../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import {PutComandaGeneradaRevisada} from "../../../dao/menudesign/comandes/PutComandaGeneradaRevisada";
import toast, {Toaster} from "react-hot-toast";
import NovaComandaModal from "./NovaComandaModal";

// Calcula el dia d'entrega: dia laborable anterior a la data d'inici
// dilluns → divendres anterior (-3), qualsevol altre → dia anterior (-1)
function calcularDiaEntrega(inici: string): string {
    try {
        const d = new Date(inici);
        const dow = d.getDay(); // 0=diumenge, 1=dilluns...
        d.setDate(d.getDate() - (dow === 1 ? 3 : 1));
        return format(d, 'dd-MM-yyyy');
    } catch {
        return '-';
    }
}

const btnText: React.CSSProperties = {
    padding: 0,
    height: 'auto',
    lineHeight: '1',
    border: 'none',
    background: 'transparent',
    boxShadow: 'none',
};

const GestorComandes = () => {
    const titol: string = "Gestor de Comandes";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const {id} = useParams();

    const [coleccio, setDades] = useState<ComandaGenerada[]>([]);
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);

    const permisEdicio = user.pagines.find(
        (pagina: any) => pagina.descripcio === "Gestió de Comandes" && pagina.tipus === 1
    );

    useEffect(() => {
        if (isLoggedIn) checkDades();
    }, [id]);

    async function checkDades() {
        setLoading(true);
        const dades = await GetComandesGenerades(page);
        setDades(Array.isArray(dades) ? dades : []);
        setLoading(false);
    }

    function handleCloseModal(value: boolean) {
        if (value) toast.success("GUARDAT");
        else toast.error("NO GUARDAT");
        setNouElement(false);
        checkDades();
    }

    async function handleDownload(ele: ComandaGenerada) {
        setLoading(true);
        const url = await GetComandesGeneradesIdPdf(page, ele.id + "");
        if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = `ComandaGenerada${ele.id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(false);
    }

    async function handleToggleRevisada(ele: ComandaGenerada) {
        const novaRevisada = ele.revisada === 1 ? 0 : 1;
        const ok = await PutComandaGeneradaRevisada(page, ele.id, novaRevisada, userId);
        if (ok) {
            setDades(prev => prev.map(item =>
                item.id === ele.id ? {...item, revisada: novaRevisada} : item
            ));
            toast.success(novaRevisada === 1 ? "Marcada com a revisada" : "Desmarcada com a revisada");
        } else {
            toast.error("Error en canviar l'estat de revisió");
        }
    }

    const columns: ColumnsType<ComandaGenerada> = [
        {
            key: 'id', title: 'ID', dataIndex: 'id', width: 60, responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'proveidor', title: 'Proveïdor', dataIndex: 'proveidor', width: 150,
            sorter: (a, b) => a.proveidor.localeCompare(b.proveidor),
        },
        {
            key: 'inici', title: "Data d'inici", dataIndex: 'inici', width: 110, responsive: ['lg'],
            render: (_, ele) => <Tag>{format(new Date(ele.inici), 'dd-MM-yyyy')}</Tag>
        },
        {
            key: 'fin', title: 'Data final', dataIndex: 'fin', width: 110, responsive: ['lg'],
            render: (_, ele) => <Tag>{format(new Date(ele.fin), 'dd-MM-yyyy')}</Tag>
        },
        {
            key: 'creacio', title: 'Creació', dataIndex: 'creacio', width: 110,
            render: (_, ele) => <Tag color="green">{format(new Date(ele.creacio), 'dd-MM-yyyy')}</Tag>
        },
        {
            key: 'setmana', title: 'Setmana', dataIndex: 'setmana', width: 80, responsive: ['lg'],
            render: (_, ele) => <Tag>W-{ele.setmana}</Tag>
        },
        {
            key: 'diaEntrega', title: 'Dia Entrega', dataIndex: 'inici', width: 110, responsive: ['lg'],
            render: (_, ele) => <Tag color="orange">{calcularDiaEntrega(ele.inici as unknown as string)}</Tag>
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 120,
            render: (_, ele) => {
                const isManual = ele.generada === 1;
                const isRevisada = ele.revisada === 1;
                const isMagatzem = ele.estat === 1 || ele.estat === 2;

                // 4 variants de la icona revisada (manual/auto × revisat/no revisat)
                const iconRevisada = isManual
                    ? (isRevisada
                        ? <BsClipboardCheckFill size={22} color="green"/>
                        : <BsClipboardCheck size={22} color="red"/>)
                    : (isRevisada
                        ? <BsCheckCircleFill size={22} color="green"/>
                        : <BsCheckCircle size={22} color="red"/>);

                const iconDownload = isMagatzem
                    ? <BsBoxArrowInDown size={22} color="#1677ff"/>
                    : <BiDownload size={22} color="#1677ff"/>;

                const iconEnviat = ele.enviat === 1
                    ? <BsEnvelopeOpen size={20} color="green"/>
                    : <BsEnvelope size={20} color="red"/>;

                return (
                    <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                        <Tooltip title={isRevisada ? "Desmarcar revisada" : "Marcar com a revisada"}>
                            <Button type="text" style={btnText} onClick={() => handleToggleRevisada(ele)}>
                                {iconRevisada}
                            </Button>
                        </Tooltip>

                        <Tooltip title={isMagatzem ? "Descarregar previsió (Magatzem)" : "Descarregar comanda (Escoles)"}>
                            <Button type="text" style={btnText} onClick={() => handleDownload(ele)}>
                                {iconDownload}
                            </Button>
                        </Tooltip>

                        <Tooltip title={ele.enviat === 1 ? "Enviat" : "No enviat"}>
                            <span style={{cursor: 'default', display: 'flex', alignItems: 'center'}}>
                                {iconEnviat}
                            </span>
                        </Tooltip>
                    </div>
                );
            },
        }
    ];

    const tableProps: TableProps<ComandaGenerada> = {loading};

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"} style={{alignItems: "center", display: "flex"}}>
                            {permisEdicio && (
                                <Button
                                    title={"Nova Comanda"}
                                    style={{backgroundColor: Colors.colors.color2}}
                                    onClick={() => setNouElement(true)}
                                >
                                    <BiPlus/>
                                </Button>
                            )}
                            <Button
                                title={"Refrescar"}
                                style={{backgroundColor: Colors.colors.color4}}
                                onClick={checkDades}
                            >
                                <BiRefresh/>
                            </Button>
                        </div>
                        <h4 className={"titol"}>{titol}</h4>
                        <Table
                            {...tableProps}
                            columns={columns}
                            pagination={{pageSize: 100}}
                            dataSource={coleccio}
                            rowKey="id"
                        />
                    </Card>
                    <br/>
                    <Historials pantalla={"GESTIOCOMANDES"} pagina={page}/>
                    {nouElement && (
                        <NovaComandaModal onClose={handleCloseModal} visible={nouElement}/>
                    )}
                </div>
            </div>
        );
    } else {
        return <Login/>;
    }
};

export default GestorComandes;
